import React from "react";

import { SegmentView } from "@tiny/api";
import { DataList } from "@tiny/components";
import { ContentComponentProps } from "../../SearchPanel/SearchPanel.types";
import SegmentItemDetails from "../SegmentItemDetails/SegmentItemDetails";
import SegmentItemMain from "../SegmentItemMain/SegmentItemMain";

function SegmentListContent(props: ContentComponentProps<SegmentView>) {
  return (
    <DataList
      {...props}
      ItemMainComponent={SegmentItemMain}
      ItemDetailsComponent={SegmentItemDetails}
    />
  );
}

export default SegmentListContent;
